import { Component, Input } from '@angular/core';


@Component({
    selector: 'soft-lstfix-fieldok-list-view',
    imports: [],
    templateUrl: './list-view.component.html',
    styleUrl: './list-view.component.css'
})
export class LstfixListViewComponent {

  @Input() item!: Record<string, unknown>
}
